import React from "react";
import { ReactComponent as EmmptyDerivatives } from "../../assets/images/svg/emptyDerivatives.svg";

const EmptyDerivatives = ({ image, message }) => {
  return (
    <div className="empty_derivatives_outside">
      <div className="empty_derivaties_inside_main">
        {image ? (
          <img src={image} alt="no_derivatives" />
        ) : (
          <EmmptyDerivatives />
        )}

        <h2 className="empty_derivative_comment">
          {message
            ? message
            : "You do not have any Derivatives investments held with Nuvama"}
        </h2>
      </div>
    </div>
  );
};

export default EmptyDerivatives;
